let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1gaf4")).then(() => parcelRequire('giI7i'));